import {ParameterGroup} from '../Parameters.types'

export function getSectionTitle(type: ParameterGroup) {
  switch (type) {
    case ParameterGroup.CONFIGURATION:
      return 'Configuration Parameters'
    case ParameterGroup.SYSTEM:
      return 'System properties'
    case ParameterGroup.ENVIRONMENT:
      return 'Environment variables'
    case ParameterGroup.DEPENDENCIES:
      return 'Parameters from Dependencies'
    default:
      return ''
  }
}
